import { render, staticRenderFns } from "./ParametreSms.vue?vue&type=template&id=28d635a2"
import script from "./ParametreSms.vue?vue&type=script&lang=js"
export * from "./ParametreSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports